import {
  CheckCircleOutlined,
  CloseOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { notification } from 'antd'
import React from 'react'
import { theme } from 'src/branding/omsTheme'

export const SuccessNotification = ({
  message,
  description,
  duration = 3,
  key,
  btn,
}) => {
  notification.open({
    message,
    description,
    duration,
    key,
    btn,
    icon: <CheckCircleOutlined style={{ color: theme.colours.lettuceGreen }} />,
  })
}

export const RejectedNotification = ({ message, description }) => {
  notification.open({
    message,
    description,
    duration: 3,
    icon: <CloseOutlined style={{ color: theme.colours.chilliRed }} />,
  })
}

export const WarningNotification = ({ message, description }) => {
  notification.open({
    message,
    description,
    duration: 6,
    icon: <WarningOutlined style={{ color: '#d48806' }} />,
  })
}
